/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_E2_Extra_Point_3_LabelInputs */

const en_visa_e2_extra_point_3_label = /** @type {(inputs: Visa_E2_Extra_Point_3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forward Planning`)
};

const pt_visa_e2_extra_point_3_label = /** @type {(inputs: Visa_E2_Extra_Point_3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planejamento Futuro`)
};

const es_visa_e2_extra_point_3_label = /** @type {(inputs: Visa_E2_Extra_Point_3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planificación Futura`)
};

/**
* | output |
* | --- |
* | "Forward Planning" |
*
* @param {Visa_E2_Extra_Point_3_LabelInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_e2_extra_point_3_label = /** @type {((inputs?: Visa_E2_Extra_Point_3_LabelInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_E2_Extra_Point_3_LabelInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_e2_extra_point_3_label(inputs)
	if (locale === "es") return es_visa_e2_extra_point_3_label(inputs)
	return en_visa_e2_extra_point_3_label(inputs)
});